import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { CartItem } from '../entities/cart-item';

export interface CartItemDialogData {
  item: CartItem;
  isNewItem: boolean;
  currencySymbol: string;
}

@Component({
  selector: 'app-b2b-cart-item-dialog',
  templateUrl: './b2b-cart-item-dialog.component.html',
  styleUrls: ['./b2b-cart-item-dialog.component.scss'],
  standalone: false
})
export class B2bCartItemDialogComponent implements OnInit {
  appStrings;
  itemNumberControl: FormControl;
  quantityControl: FormControl;
  isNewItem: boolean;
  item: CartItem;
  currencySymbol: string;

  constructor(
    public dialogRef: MatDialogRef<B2bCartItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CartItemDialogData,
    public appInfoService: AppInfoService
  ) {
    this.item = data.item;
    this.isNewItem = data.isNewItem;
    this.currencySymbol = data.currencySymbol;
  }

  ngOnInit(): void {
    this.appStrings = this.appInfoService.appStrings;
    this.initializeFormControls();
  }

  private initializeFormControls(): void {
    this.itemNumberControl = new FormControl(
      this.item.ModelNumber || '',
      [Validators.required]
    );

    this.quantityControl = new FormControl(
      this.item.Quantity || 1,
      [Validators.required, Validators.min(1)]
    );
  }

  getTotalPrice(): number {
    const quantity = Number(this.quantityControl.value) || 0;
    return quantity * (this.item.NetPrice ?? 0);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    this.itemNumberControl.markAsTouched();
    this.quantityControl.markAsTouched();

    if (this.itemNumberControl.invalid || this.quantityControl.invalid) {
      return;
    }

    const result = {
      itemNumber: this.itemNumberControl.value.toUpperCase().trim(),
      quantity: Number(this.quantityControl.value),
      isNewItem: this.isNewItem
    };

    this.dialogRef.close(result);
  }
}
